/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import Moment from "react-moment";
import {
  addList,
  getList,
  getListById,
  updateList
} from "../../services/services";
import { ENDPOINT } from "../../services/api-endpoint";
import AppLoader from "../../components/AppLoader";
import { usePageLoader } from "../../services/usePageLoader";
import { useConfirmDialog } from "../../services/useConfirmDialog";
import MesEmptyState from "../../components/mes-empty-state/mes-empty-state";
import "./mes-tasks.scss";

const MesTasks = () => {
  const [validated, setValidated] = useState(false);
  const [formInputs, setForm] = useState<any>({});
  const [editId, setEditId] = useState<any>("");
  const [workCenterList, setWorkCenterList] = useState<any[]>([]);
  const [operationCollection, setOperation] = useState<any[]>([]);
  const [jobsCollection, setJobs] = useState<any[]>([]);
  const [taskCollection, setTask] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pageSize] = useState<number>(9);
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>("");
  const [openAddUpdateModal, setAddUpdateModal] = useState<boolean>(false);
  const { isLoading, runWithLoading } = usePageLoader();
  const { confirm, ConfirmDialog } = useConfirmDialog();
 
  const handleClose = () => {
    setEditId("");
    setForm({});
    setAddUpdateModal(false);
  };

  const handleShow = () => {
    setValidated(false);
    onLoadWorkCenter();
    onLoadJobs();
    onLoadOperation();
    setAddUpdateModal(true);
  };

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setForm((values: any) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    onSave();
  };

  async function onSave() {
    try {
      let saveOperation;
      const request = {
        ...formInputs,
        jobid: Number(formInputs.jobid),
        operationid: Number(formInputs.operationid),
        workcenterid: Number(formInputs.workcenterid),
        totalparts: Number(formInputs.totalparts),
        assigneeid: 1,
        active: true,
        createdby: 10,
        id: editId ? editId : null,
        updatedby: 10
      };
      if (editId) {
        saveOperation = await updateList(ENDPOINT.TASK_UPDATE, request);
      } else {
        saveOperation = await addList(ENDPOINT.TASK_ADD, request);
      }
      if (saveOperation === "success") {
        onLoad(pageIndex, searchText);
        handleClose();
      }
    } catch (e) {
      console.log(`Error in addupdate: ${e}`);
    }
  }

  
  async function onEdit(id: any) {
    try {
      const editWork = await getListById(ENDPOINT.TASK_LIST_BY_ID, id);
      setEditId(editWork[0].id);
      setForm(editWork[0]);
      handleShow();
    } catch (e) {
      console.log(`Error in edittask: ${e}`);
    }
  }

  async function onDelete(list: any) {
    const isConfirmed = await confirm();
    if (!isConfirmed) return;

    try {
      list.active = false;
      list.createdby = 10;
      list.updatedby = 10;
      let saveWork = await updateList(ENDPOINT.TASK_UPDATE, list);
      if (saveWork === "success") {
        onLoad(pageIndex, searchText);
      }
    } catch (e) {
      console.log(`Error in deletetask: ${e}`);
    }
  }

  async function onLoadJobs() {
    try {
      const list = await runWithLoading(async () => {
        return getList(ENDPOINT.JOB_LIST);
      });
      setJobs(list);
    } catch (e) {
      console.log(`Error in getJobList: ${e}`);
    }
  }

  async function onLoadOperation() {
    try {
      const list = await runWithLoading(async () => {
        return getList(ENDPOINT.OPERATIONS_LIST);
      });
      setOperation(list);
    } catch (e) {
      console.log(`Error in getOperationList: ${e}`);
    }
  }

  async function onLoadWorkCenter() {
    try {
      const list = await runWithLoading(async () => {
        return getList(ENDPOINT.WORK_CENTER_LIST);
      });
      setWorkCenterList(list);
    } catch (e) {
      console.log(`Error in getWorkList: ${e}`);
    }
  }

  const onLoad = useCallback(
    async (nextPageIndex: number = 0, overrideSearchText?: string) => {
      try {
        await runWithLoading(async () => {
          const effectiveSearchText =
            overrideSearchText !== undefined ? overrideSearchText : searchText;

          const resp = await getList(ENDPOINT.TASK_LIST, {
            pagesize: pageSize,
            pagenumber: nextPageIndex,
            serachtext: effectiveSearchText,
          });
          const items = Array.isArray(resp) ? resp : resp?.data || [];
          const count = Array.isArray(resp)
            ? items.length
            : Number(resp?.count || 0);
          setTask(items);
          setTotalCount(count);
          setPageIndex(nextPageIndex);
        });
      } catch (e) {
        console.log(`Error in getOperation: ${e}`);
      }
    },
    [searchText, runWithLoading, pageSize],
  );

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const totalPages = Math.ceil(totalCount / pageSize);
  const showPagination = totalPages > 1;
  const hasRecords = taskCollection?.length > 0;

  return (
    <div>
      {isLoading && <AppLoader text="Loading tasks..." />}
      <div className="jobs-details tv-page-content">
          <div className="tv-list-head-row">
            <button
              type="button"
              className="btn btn-primary tv-list-add-btn"
              onClick={handleShow}
            >
              <span>
                <i className="fa fa-plus-circle" aria-hidden="true"></i>
              </span>
              Add Task
            </button>
          </div>

          <div className="clearfix pt-20">
            <div className="tv-list-panel">
              {hasRecords && (
                <div className="tv-list-search-row">
                  <input
                    type="text"
                    placeholder="Search Tasks"
                    className="form-control search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        onLoad(0, (e.target as HTMLInputElement).value);
                      }
                    }}
                  />
                  <i
                    className="fa fa-search"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={() => onLoad(0, searchText)}
                  ></i>
                </div>
              )}
              <div className="pt-20">
                {!hasRecords ? (
                  !isLoading && (
                    <MesEmptyState
                      icon="fa-check"
                      title="No Tasks Found"
                      subtitle="Add your first task to start tracking execution."
                    />
                  )
                ) : (
                  <Row xs={1} md={3} className="g-4">
                    {taskCollection?.map((list: any, index) => (
                      <Col key={index.toString()} className="pt-20">
                        <Card className="card_task">
                          <Card.Body>
                            <div className="borderBottom">
                              <div className="row">
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Job Name</dt>
                                    <dd>{list.jobname}</dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Operation Name</dt>
                                    <dd>{list.totalparts}</dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Workcenters Name</dt>
                                    <dd>{list.partproduced}</dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Estimated Start Date</dt>
                                    <dd>
                                      <Moment format="MMM DD, YYYY">
                                        {list.estimatedstartdate}
                                      </Moment>
                                    </dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Estimated End Date</dt>
                                    <dd>
                                      <Moment format="MMM DD, YYYY">
                                        {list.estimatedenddate}
                                      </Moment>
                                    </dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Actual Start Date</dt>
                                    <dd><Moment format="MMM DD, YYYY">
                                        {list.actualstartdate}
                                      </Moment></dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Actual End Date</dt>
                                    <dd><Moment format="MMM DD, YYYY">
                                        {list.actualenddate}
                                      </Moment></dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Type</dt>
                                    <dd>{list.tasktype}</dd>
                                  </dl>
                                </div>
                                <div className="col-sm-12">
                                  <dl className="cls-dl-horizontal">
                                    <dt>Total Parts</dt>
                                    <dd>{list.totalparts}</dd>
                                  </dl>
                                </div>
                              </div>
                            </div>
                            <div className="mt-20 ">
                              <ul className="Icons unstyled">
                                <li className="pl-3">
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Delete"
                                    onClick={() => onDelete(list)}
                                  >
                                    <i
                                      className="fa fa-trash"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </li>
                                <li className="pl-3">
                                  <a onClick={() => onEdit(list.id)}>
                                    <span
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Edit"
                                    >
                                      <i
                                        className="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </div>

              {showPagination && (
                <div className="clearfix paginate mt-10 tv-list-pagination">
                  <nav aria-label="Tasks pagination">
                    <ul className="pagination">
                      <li className={`page-item ${pageIndex === 0 ? "disabled" : ""}`}>
                        <a
                          className="page-link"
                          href="#"
                          aria-label="Previous"
                          onClick={(e) => {
                            e.preventDefault();
                            if (pageIndex > 0) onLoad(pageIndex - 1);
                          }}
                        >
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>

                      {Array.from({ length: totalPages }).map((_, i) => (
                        <li
                          key={i}
                          className={`page-item ${i === pageIndex ? "active" : ""}`}
                        >
                          <a
                            className="page-link"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              onLoad(i);
                            }}
                          >
                            {i + 1}
                          </a>
                        </li>
                      ))}

                      <li
                        className={`page-item ${
                          pageIndex >= totalPages - 1 ? "disabled" : ""
                        }`}
                      >
                        <a
                          className="page-link"
                          href="#"
                          aria-label="Next"
                          onClick={(e) => {
                            e.preventDefault();
                            if (pageIndex < totalPages - 1) onLoad(pageIndex + 1);
                          }}
                        >
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      <Modal size="lg" centered show={openAddUpdateModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Add Task</Modal.Title>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            id="myForm"
          >
            <Row className="mb-2">
            <Form.Group as={Col} md="6" controlId="jobid">
                <Form.Label>Job</Form.Label>
                <Form.Control
                  as="select"
                  required
                  name="jobid"
                  value={formInputs.jobid || ""}
                  onChange={(e) => handleChange(e)}
                >
                  <option value="" disabled>
                    select
                  </option>
                  {jobsCollection?.map((list: any, index) => (
                    <option key={index} value={list.id}>
                      {list.jobname}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="operationid">
                <Form.Label>Operation</Form.Label>
                <Form.Control
                  as="select"
                  required
                  name="operationid"
                  value={formInputs.operationid || ""}
                  onChange={(e) => handleChange(e)}
                >
                  <option value="" disabled>
                    select
                  </option>
                  {operationCollection?.map((list: any, index) => (
                    <option key={index} value={list.id}>
                      {list.operationname}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Row>

            <Row className="mb-2">
            <Form.Group as={Col} md="6" controlId="workcenterid">
                <Form.Label>Workcenters</Form.Label>
                <Form.Control
                  as="select"
                  required
                  name="workcenterid"
                  value={formInputs.workcenterid || ""}
                  onChange={(e) => handleChange(e)}
                >
                  <option value="" disabled>
                    select
                  </option>
                  {workCenterList?.map((list: any, index) => (
                    <option key={index} value={list.id}>
                      {list.workcentername}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="assigneeid">
                <Form.Label>Assignees</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="6" controlId="expectedstartdate">
                <Form.Label>Expected Start Date</Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="expectedstartdate"
                  value={formInputs.expectedstartdate || ""}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="expectedenddate">
                <Form.Label>Expected End Date</Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="expectedenddate"
                  value={formInputs.expectedenddate || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="6" controlId="actualstartdate">
                <Form.Label>Actual Start Date</Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="actualstartdate"
                  value={formInputs.actualstartdate || ""}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="actualenddate">
                <Form.Label>Actual End Date</Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="actualenddate"
                  value={formInputs.actualenddate || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="6" controlId="scrap">
                <Form.Label>Scrap</Form.Label>
                <Form.Control
                  required
                  type="time"
                  name="scrap"
                  value={formInputs.scrap || ""}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="tasktype">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="tasktype"
                  value={formInputs.tasktype || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="6" controlId="totalparts">
                <Form.Label>Total Parts</Form.Label>
                <Form.Control
                  required
                  type="number"
                  name="totalparts"
                  value={formInputs.totalparts || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" form="myForm">
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <ConfirmDialog />
    </div>
  );
};
export default MesTasks;
